import isNil from 'lodash/isNil';
import negate from 'lodash/negate';

export const getFullName = ({ firstName, lastName }) =>
  [firstName, lastName].filter(negate(isNil)).join(' ').trim();
